// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_ic-3";
export var flatBottomCorners = "_ic-5";
export var productImage = "_ic-0";
export var quantityContainer = "_ic-2";
export var quantityHeader = "_ic-6";
export var tooltip = "_ic-1";
export var wrapAndEllipsesOverflow = "_ic-4";